import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import * as actionCreators from "../../../actions/user";
import * as tourActions from "../../../actions/tour";

import Avatar from "material-ui/Avatar";
import { AppBar } from "@material-ui/core";
// import Drawer from '@material-ui/core/Drawer';
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";

import IconLogout from "material-ui/svg-icons/action/input";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import NormalFlatButton from "../../../components/common/NormalFlatButton";

import logo from "../../../resources/logo/ac-logo-text.png";
import Badge from "material-ui/Badge";

import events from "../../../services/events";

import colors from "../../../styles/colors";
import { colorsV2 } from "../../../styles/colors";

const style = {
  container: {
    display: "flex",
    flexFlow: "row",
    width: "100%",
    minHeight: 20,
  },
  header: {
    backgroundColor: colorsV2.primary,
    display: "flex",
    textAlign: "left",
    width: "100%",
  },
  list: {
    backgroundColor: colorsV2.primary,
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  link: {
    height: 50,
    textDecoration: "none",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    justifyItems: "center",
    alignContent: "center",
    alignItems: "center",
  },
  item: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    justifyItems: "center",
    alignContent: "center",
    alignItems: "center",
  },
  icon: {
    marginRight: 12,
  },
  text: {
    fontFamily: "Poppins-Regular",
    display: "inline-block",
    color: "white",
    fontSize: 16,
  },
  footer: {
    position: "fixed",
    bottom: 60,
    width: 246,
    display: "flex",
    flexFlow: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  avatar: {
    margin: 5,
  },
  subLink: {
    textDecoration: "none",
    fontSize: 12,
  },
  subText: {
    fontFamily: "Poppins-Regular",
    display: "inline-block",
    color: "white",
    fontSize: 14,
  },
};

class SideNavMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      unreadMessageCount: this.countUnread(this.props.inbox),
      isProvider: this.props.isProvider,
      optionsType: "",
      open: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.inbox) {
      this.setState({
        unreadMessageCount: this.countUnread(nextProps.inbox),
      });
    }

    if (nextProps.userInfo) {
      this.setState({ isProvider: nextProps.isProvider });
    }

    this.setState({ optionsType: nextProps.optionsType });
  }

  countUnread(inbox) {
    let unread = 0;
    try {
      inbox.forEach((item) => {
        unread = unread + item.unreadMsgCount;
      });
    } catch (error) {}
    return unread;
  }

  render() {
    return (
      <div style={style.container}>
        <AppBar
          position="static"
          style={{
            width: "100%",
            backgroundColor: this.props.whiteLabelSettings.isWhiteLabel
              ? this.props.whiteLabelSettings.primaryColor
              : colorsV2.primary,
          }}
        >
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={() => this.setState({ open: !this.state.open })}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              variant="h6"
              style={
                ({ ...style.header },
                {
                  backgroundColor: this.props.whiteLabelSettings.isWhiteLabel
                    ? this.props.whiteLabelSettings.primaryColor
                    : "",
                })
              }
            >
              {this.props.title}
            </Typography>
          </Toolbar>
        </AppBar>
        <SwipeableDrawer
          open={this.state.open}
          onClose={() => this.setState({ open: false })}
        >
          <div style={style.list}>
            <div style={style.item}>
              {this.props.whiteLabelSettings.isWhiteLabel && (
                <div style={{ height: "100px" }} />
              )}
              {!this.props.whiteLabelSettings.isWhiteLabel && (
                <img src={logo} alt="AC Health Logo" />
              )}
            </div>
            <div style={style.list}>
              <Link
                to={`/view-channels/${this.props.userId}`}
                style={style.link}
                className={"step_6"}
                onClick={() => {
                  try {
                    events().trackUserEvent(
                      "View Channel List",
                      null,
                      null,
                      null,
                      null,
                      this.props.user.userId,
                      null,
                      "portal",
                      null,
                      null,
                      null
                    );
                  } catch (ex) {}
                }}
              >
                <label style={style.text}>View My Channels</label>
              </Link>
              {this.state.isProvider && this.props.apps.providerAppId && (
                <Link
                  to={"/manage-users/" + this.props.apps.providerAppId}
                  style={style.link}
                  onClick={() => {
                    try {
                      const app =
                        this.props.apps.appInfos[this.props.apps.providerAppId];
                      events().trackUserEvent(
                        "View Channel",
                        app.appId,
                        null,
                        null,
                        null,
                        this.props.user.userId,
                        null,
                        "portal",
                        app.appName,
                        null,
                        null
                      );
                    } catch (ex) {}
                  }}
                >
                  <label style={style.subText}>My Patients/Clients</label>
                </Link>
              )}
              {this.state.isProvider && this.props.apps.providerAppId && (
                <Link
                  to={"/libraries/" + this.props.apps.providerAppId}
                  style={style.link}
                  onClick={() => {
                    try {
                      events().trackUserEvent(
                        "View Library",
                        this.props.apps.providerAppId,
                        null,
                        null,
                        null,
                        this.props.user.userId,
                        null,
                        "portal",
                        this.props.apps.appInfos[this.props.apps.providerAppId]
                          .appName,
                        null,
                        null
                      );
                    } catch (ex) {}
                  }}
                >
                  <label style={style.subText}>Manage Library</label>
                </Link>
              )}
              {this.state.isProvider &&
                this.props.apps.providerAppId &&
                this.props.apps.appInfos[this.props.apps.providerAppId]
                  .appType === "Standard" && (
                  <Link
                    to={"/manage-programs/"}
                    style={style.link}
                    onClick={() => {
                      try {
                        events().trackUserEvent(
                          "View Manage Programs",
                          this.props.apps.providerAppId,
                          null,
                          null,
                          null,
                          this.props.user.userId,
                          null,
                          "portal",
                          this.props.apps.appInfos[
                            this.props.apps.providerAppId
                          ].appName,
                          null,
                          null
                        );
                      } catch (ex) {}
                    }}
                  >
                    <label style={style.subText}>Manage Programs</label>
                  </Link>
                )}
              {this.state.isProvider &&
                (this.props.optionsType === "manage-users" ||
                  this.props.optionsType === "RTM") && (
                  <Link
                    to={"/rtm/" + this.props.apps.providerAppId}
                    style={style.link}
                    onClick={() => {
                      try {
                        events().trackUserEvent(
                          "View RTM",
                          this.props.apps.providerAppId,
                          null,
                          null,
                          null,
                          this.props.user.userId,
                          null,
                          "portal",
                          this.props.apps.appInfos[
                            this.props.apps.providerAppId
                          ].appName,
                          null,
                          null
                        );
                      } catch (ex) {}
                    }}
                  >
                    <label style={style.text}>Manage RTM</label>
                  </Link>
                )}
              {this.state.isProvider &&
                this.props.optionsType == "channels" && (
                  <Link
                    to="/create-app"
                    style={style.link}
                    onClick={() => {
                      try {
                        events().trackUserEvent(
                          "View Create New Channel",
                          this.props.apps.providerAppId,
                          null,
                          null,
                          null,
                          this.props.user.userId,
                          null,
                          "portal",
                          this.props.apps.appInfos[
                            this.props.apps.providerAppId
                          ].appName,
                          null,
                          null
                        );
                      } catch (ex) {}
                    }}
                  >
                    <label style={style.text}>Create New Channel</label>
                  </Link>
                )}

              {this.props.user.isOrgAdmin && (
                <Link
                  to={`/manage-org-members`}
                  style={style.link}
                  onClick={() => {
                    try {
                      events().trackUserEvent(
                        "View Manage Org",
                        null,
                        null,
                        null,
                        null,
                        this.props.user.userId,
                        null,
                        "portal",
                        null,
                        null,
                        null
                      );
                    } catch (ex) {}
                  }}
                >
                  <label style={style.text}>Manage Organization</label>
                </Link>
              )}
              {this.state.isProvider &&
                this.props.organization.orgId !== -1 && (
                  <Link
                    to={`/manage-org-clients`}
                    style={style.link}
                    onClick={() => {
                      try {
                        events().trackUserEvent(
                          "View Manage Patients/Clients",
                          null,
                          null,
                          null,
                          null,
                          this.props.user.userId,
                          null,
                          "portal",
                          null,
                          null,
                          null
                        );
                      } catch (ex) {}
                    }}
                  >
                    <label style={style.text}>Manage Patients/Clients</label>
                  </Link>
                )}

              {this.state.isProvider &&
                this.props.organization.orgId !== -1 && (
                  <Link
                    to={`/org-reports`}
                    style={style.link}
                    onClick={() => {
                      try {
                        events().trackUserEvent(
                          "View Org Reports",
                          null,
                          null,
                          null,
                          null,
                          this.props.user.userId,
                          null,
                          "portal",
                          null,
                          null,
                          null
                        );
                      } catch (ex) {}
                    }}
                  >
                    <label style={style.text}>Organization Reports</label>
                  </Link>
                )}

              <Link
                to={`/message-inbox/${this.props.userId}`}
                style={style.link}
                onClick={() => {
                  try {
                    events().trackUserEvent(
                      "View Message Inbox",
                      null,
                      null,
                      null,
                      null,
                      this.props.user.userId,
                      null,
                      "portal",
                      null,
                      null,
                      null
                    );
                  } catch (ex) {}
                }}
              >
                <label style={style.text}>Message Inbox</label>
              </Link>
              <Link
                to={`/external-resources/${this.props.userId}`}
                style={style.link}
                className={"step_7"}
                onClick={() => {
                  try {
                    events().trackUserEvent(
                      "View Resource List",
                      null,
                      null,
                      null,
                      null,
                      this.props.user.userId,
                      null,
                      "portal",
                      null,
                      null,
                      null
                    );
                  } catch (ex) {}
                }}
              >
                <label style={style.text}>External resources</label>
              </Link>
              <Link
                to={`/profile/${this.props.userId}`}
                style={style.link}
                className={"step_9"}
                onClick={() => {
                  try {
                    events().trackUserEvent(
                      "View Profile",
                      null,
                      null,
                      null,
                      null,
                      this.props.user.userId,
                      null,
                      "portal",
                      null,
                      null,
                      null
                    );
                  } catch (ex) {}
                }}
              >
                <label style={style.text}>My Profile</label>
              </Link>
            </div>

            <div style={style.footer}>
              <Avatar
                style={style.avatar}
                src={this.props.userInfo && this.props.userInfo.profilePhotoUrl}
                size={96}
              />
              <br />

              {this.state.isProvider && (
                <Link to="/view-channels" style={style.link}>
                  <NormalFlatButton
                    style={{ color: colors.lightGrey }}
                    label="Show Guided Tour"
                    onClick={() => this.props.showTour()}
                  />
                </Link>
              )}
              <Link
                to="/"
                className={"step_10"}
                onClick={() => {
                  try {
                    events().trackUserEvent(
                      "Logout",
                      null,
                      null,
                      null,
                      null,
                      this.props.user.userId,
                      null,
                      "portal",
                      null,
                      null,
                      null
                    );
                  } catch (ex) {}
                }}
              >
                <NormalFlatButton
                  icon={<IconLogout />}
                  style={{ color: "white" }}
                  label="Log Out"
                  onClick={() =>
                    this.props.userLogOut(-1, this.props.user.email)
                  }
                />
              </Link>
            </div>
          </div>
        </SwipeableDrawer>
      </div>
    );
  } //end render
}

function mapStateToProps({
  user,
  message,
  apps,
  tour,
  whiteLabelSettings,
  messages,
  organization,
}) {
  return {
    user,
    userId: user.userId,
    userProfile: user.profile,
    userInfo: user.userInfo,
    notifications: message.notifications,
    apps,
    tour,
    whiteLabelSettings,
    organization,

    inbox: messages.inbox,
    isProvider:
      user.userInfo && user.userInfo.isProvider
        ? user.userInfo.isProvider
        : false,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...tourActions, ...actionCreators }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SideNavMobile);



// WEBPACK FOOTER //
// ./src/layout/Appframe/navigation/SideNavMobile.js